import { SCFPrivileges, ScfV2Service } from "./scf-v2.service";
import { Component, ElementRef, HostListener, OnInit, ViewChild, OnDestroy, OnChanges, SimpleChanges, AfterViewInit, Injector, } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatSidenav } from "@angular/material/sidenav";
import { Observable, Subscription, takeUntil } from "rxjs";
import { ScfV2SideComponent } from "./scf-v2-side/scf-v2-side.component";
import moment from "moment";
import { ScfV2MainComponent } from "./scf-v2-main/scf-v2-main.component";
import { ScfV2SettingsComponent } from "./scf-v2-settings/scf-v2-settings.component";
import { BaseComponent } from "src/app/common/base/base.component";
import { Roles, FormStatusEnum, LoadingOrigin, FormType } from "src/app/common/enumerations/enumerations";
import { YesNoDialogComponent } from "src/app/controls/yes-no-dialog/yes-no-dialog.component";
import { utils } from "src/app/modules/libs/utils";
import { FormStatus } from "src/app/services/forms/form-status";
import { Procedure } from "src/app/components/procedure/models/procedure.model";
import { PrivilegeEnum } from "src/app/common/enumerations/privilege-enum";
import { SCFMaster } from "./scf";
import { MessagePlaceholder } from "src/app/common/models/placeholder";
import { RelatedLinkDocumentBase } from "src/app/common/models/related-link-document-base.model";
import { FormViewState } from "src/app/common/models/form-view-state";
import { FormHistoryButtonComponent } from "src/app/controls/form-history/form-history-button/form-history-button.component";
import { Router } from "@angular/router";

@Component({
  selector: "scf-v2",
  templateUrl: "./scf-v2.component.html",
  styleUrls: ["./scf-v2.component.scss"],
})
export class ScfV2Component extends BaseComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

  validRoles = [Roles.FO, Roles.AO, Roles.OT];

  @ViewChild("sidenav") sidenav!: MatSidenav;
  @ViewChild("headerTop") headerTop!: ElementRef;
  @ViewChild(ScfV2SideComponent) side!: ScfV2SideComponent;
  @ViewChild(ScfV2MainComponent) main!: ScfV2MainComponent;

  @ViewChild(FormHistoryButtonComponent) public showHistory!: FormHistoryButtonComponent;
  disabled: boolean = false;

  resourceRequired: boolean = false;

  filterCtrl = new FormControl();

  errorMessages: string[] = [];

  headerOnTop: boolean = false;

  procedure?: Procedure;
  procedures: Procedure[] = [];
  procedures$!: Observable<Procedure[]>;
  proceduresSubs: Subscription = new Subscription;
  procedureAppendix?: RelatedLinkDocumentBase;


  createdOn!: string;

  ///////
  tmpFilter!: string;
  condition!: string;
  filteredFilter: any[] = [];
  currentFilter: any;
  filter: any;
  valueFilter!: string;
  scfMasterUnchanged?: SCFMaster | null;
  scfMaster?: SCFMaster | null;
  scfMasters: SCFMaster[] = [];
  scfMasters$!: Observable<SCFMaster[]>;
  scfMastersSubs: Subscription = new Subscription;

  loadingMessage!: string;

  privileges: SCFPrivileges = new SCFPrivileges();
  public status: FormViewState = new FormViewState();;

  showAmendmentToggle: boolean = false;
  private resizeTimer: any;
  //////

  constructor(
    public scfService: ScfV2Service,
    protected override injector: Injector
  ) {
    super(injector);
    this.router = injector.get(Router);
  }

  private router!: Router;

  ngAfterViewInit(): void {
    this.setHeights();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadSCFs();
  }

  ngOnInit() {
    this.loadSCFs();
    this.checkPrivileges();
    this.loadProcedures();
  }

  override currentUserUpdated(): void {
    this.checkPrivileges();
  };

  loadSCFs() {
    this.scfMasters$ = this.store.select((state) => state.SCFMasters.data);
    this.scfMastersSubs = this.scfMasters$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data && data.length > 0) {
        this.scfMasters = data.filter((x) => x.serialNo !== "");
        if (this.scfMaster) {
          const scfMaster = this.scfMasters.find((x) => x.id == this.scfMaster?.id);
          if (scfMaster) {
            if (this.scfMaster.formStatus?.id != scfMaster?.formStatus?.id)
              this.showStatusChangeMessage(scfMaster);
            this.scfMaster = scfMaster;
            this.rowSelected(this.scfMaster);
          }
        }
        this.checkPrivileges();
      }
    });
  }

  showStatusChangeMessage(scfMaster: SCFMaster) {
    this.alert.message("formStateChanged", [
      new MessagePlaceholder("{serialNo}", scfMaster.serialNo), new MessagePlaceholder("{status}", scfMaster.statusName ?? 'New'),]);
  }

  override ngOnDestroy(): void {
    this.scfMastersSubs?.unsubscribe();
    this.proceduresSubs?.unsubscribe();
  }

  clear() {
    this.errorMessages = [];
  }

  loadProcedures() {
    this.procedures$ = this.store.select((state) => state.Procedures.data);
    this.proceduresSubs = this.procedures$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        this.procedures = data;
        this.procedure = this.procedures?.find(x => x.procedureMasterID == 41);
        this.procedureAppendix = this.procedure?.procedureAppendices?.find(x => x.text?.includes("Appendix 1a")
        );
      }
    });
  }

  async create() {
    if (await this.canDeactivate()) {
      this.scfService
        .getSerialNo()
        .toPromise()
        .then((data) => {
          if (data) {
            this.status.isCreating = true;
            this.scfMaster = new SCFMaster();
            this.scfMaster.name = data.serialNo;
            this.scfMaster.serialNo = data.serialNo;
            this.scfMaster.status = FormStatusEnum.New;
            this.scfMaster.formStatus = new FormStatus();
            this.scfMaster.createdBy = this.currentUser?.id;
            this.scfMaster.createdByName = this.currentUser?.name;
            this.scfMaster.relatedDocuments = [];
            this.scfMaster.createdOn = new Date();
            this.scfMaster.estimatedStartOn = new Date();
            this.scfMaster.estimatedEndOn = new Date();
            this.createdOn = moment(this.scfMaster?.createdOn).format(
              "MMM-DD-YYYY"
            );
            this.scfMaster.editingBy = this.currentUser;
            this.side.scfMaster = this.scfMaster;
            this.side.selectedRowIndex = -1;
            this.setOpenDocument(FormType.SCF, undefined);
            this.scfService
              .create(this.scfMaster)
              .toPromise()
              .then(scfMaster => {
                if (scfMaster) {
                  this.scfMaster = scfMaster;
                  this.disabled = false;
                  this.checkPrivileges();
                  this.status.isCreating = true;
                  this.status.isEditing = true;
                  if (this.scfMaster) {
                    this.scfMaster.retrievedBy = this.currentUser?.id;
                    this.side.selectedRowIndex = this.scfMaster?.id;
                  }
                  this.checkButtonsVisible();
                  this.setOpenDocument(FormType.SCF, this.scfMaster.id);
                  this.side.getValues(this.scfMaster);
                }
              });
          }
        });
    }
  }

  async edit() {
    if (await this.canDeactivate() && this.scfMaster && this.scfMasterUnchanged) {
      this.setEditing(true);
      this.status.isEditing = true;
      if (this.scfMaster)
        this.scfMasterUnchanged = utils.cloneDeep(this.scfMaster);
    }
  }

  editAmendment() {
    this.setEditing(true);
    this.status.isEditingAmendment = true;
    this.status.isViewingAmendment = true;
    if (this.scfMaster)
      this.scfMasterUnchanged = utils.cloneDeep(this.scfMaster);
  }

  async release() {
    if (!this.canReleaseEditingForm()) return;

    if (await this.canDeactivate() && this.scfMaster && this.scfMasterUnchanged) {
      const confirm = this.dialog.open(YesNoDialogComponent, {
        width: "500px", data: {
          message: this.getMessage("SCF_Release_confirmation")
            ?.description, icon: "stop",
        },
      });
      confirm.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(async (data) => {
        if (data) {
          if (this.scfMaster?.status == FormStatusEnum.New) {
            this.scfService
              .cancel(this.scfMaster, "New Form Canceled")
              .toPromise()
              .then(() => {
                this.scfMaster = null;
              });
          } else {
            this.releaseForm();
          }
        }
      });
    };
  }

  canReleaseEditingForm(): boolean {
    const isReleaseStatus =
      this.scfMaster?.status == FormStatusEnum.Draft ||
      this.scfMaster?.status == FormStatusEnum.AmendmentDrafting;
    const isCurrentEditor = this.scfMaster?.editingBy?.id == this.currentUser?.id;

    return !!(
      this.scfMaster?.editingBy &&
      isReleaseStatus &&
      (isCurrentEditor || this.hasPrivilege(PrivilegeEnum.ReleaseEditingForms))
    );
  }

  cleanSCFMaster(scfMaster: SCFMaster) {
    let clonedSCFMaster: SCFMaster = new SCFMaster();
    if (scfMaster) {
      clonedSCFMaster = utils.cloneDeep(scfMaster);
      clonedSCFMaster.wfTable = null;
      clonedSCFMaster.editingBy = null;
      clonedSCFMaster.editingById = null;
      clonedSCFMaster.editingUntil = null;
      clonedSCFMaster.updatedOn = null;
      clonedSCFMaster.updatedBy = null;
    }
    return clonedSCFMaster;
  }

  releaseForm() {
    this.status.isEditing = false;
    this.status.isEditingAmendment = false;
    this.scfMaster = this.scfMasterUnchanged;
    this.setEditing(false);
  }

  setEditing(value: boolean) {
    this.scfService
      .setEditing(this.scfMaster?.id ?? 0, value)
      .toPromise()
      .then(async () => {
        // await this.loadSCFs();
      });
  }

  @HostListener("window:resize")
  onResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.innerWidth = window.innerWidth;
      if (this.innerWidth < 768) {
        this.isExpanded = false;
      }
    }, 200);
  }

  @HostListener("window:scroll")
  isHeaderOnTop() {
    let elemRec;
    if (this.headerTop?.nativeElement !== undefined) {
      elemRec = this.headerTop.nativeElement.getBoundingClientRect();
      const docViewTop = window.screenTop;
      const elemTop = elemRec.top;
      if (elemTop <= docViewTop) {
        this.headerOnTop = true;
      } else {
        this.headerOnTop = false;
      }
    } else {
      this.headerOnTop = false;
    }
  }


  //////
  changedFilter() { }
  clearFilter() { }
  selectedFilter() { }
  createDisabled() { }
  editDisabled() { }
  action() { }

  settings() {
    const settings = this.dialog.open(ScfV2SettingsComponent, {
      width: "70vw", minWidth: "70vw", minHeight: "60vh", disableClose: true,
    });
    settings.afterClosed().subscribe(() => {
      this.checkPrivileges();
    });
  }

  applyFilter(e: any) {
    if (!e)
      this.valueFilter = '';
    this.filter = e;
  }

  rowSelected(e?: SCFMaster | any) {
    if (e?.id != this.scfMaster?.id) this.scrollToTop('sidenav-content');
    if (!e) this.showHistory.value = false;

    this.scfMaster = e as SCFMaster;
    if (
      this.scfMasterUnchanged?.status != this.scfMaster?.status &&
      this.scfMasterUnchanged?.id == this.scfMaster?.id
    ) {
      this.showStatusChangeMessage(this.scfMaster);
    }
    this.scfMasterUnchanged = e ? utils.cloneDeep(e) : null;
    this.checkPrivileges();
    this.createdOn = moment(this.scfMaster?.createdOn).format("MMM-DD-YYYY");
    this.status = new FormViewState();
    if (this.scfMaster?.status == FormStatusEnum.AmendmentDrafting) {
      this.status.isEditingAmendment =
        this.scfMaster?.editingBy?.id == this.currentUser?.id;
      this.status.isViewingAmendment = this.privileges.canViewAmendment;
    } else if (this.scfMaster?.editingBy?.id == this.currentUser?.id) {
      this.status.isEditing = true;
      this.status.isViewingAmendment = false;
      this.status.isCreating = this.scfMaster.status == FormStatusEnum.New;
    } else {
      this.status.isViewingAmendment = false;
      this.status.isEditing = false;
      this.status.isEditingAmendment = false;
    }
    this.checkDisabled();
    this.showAmendmentToggle = (this.scfMaster?.status == FormStatusEnum.AmendmentDrafting ||
      this.scfMaster?.status == FormStatusEnum.AmendmentApprovals ||
      this.scfMaster?.status == FormStatusEnum.AmendmentPending) &&
      this.canSeeAmendment();
    this.checkButtonsVisible();
    this.setHeights();

  }

  /** Navigates to the hold-point matrix when no SCF is selected. */
  openHoldPointDashboard(): void {
    this.router.navigate(['/scf-hold-points']);
  }

  buttonsVisible: boolean | null = false;

  checkButtonsVisible() {
    if (this.status)
      this.buttonsVisible =
        this.status.isCreating ||
        this.status.isEditing ||
        this.status.isEditingAmendment ||
        this.status.isCreatingAmendment ||
        this.status.isViewingAmendment ||
        (this.scfMaster?.status == FormStatusEnum.WorkApprovals &&
          (this.privileges.canUnsubmit || this.privileges.canCancel)) ||
        (this.scfMaster?.status == FormStatusEnum.PendingActivation &&
          this.privileges.canCancel) ||
        (this.scfMaster?.status == FormStatusEnum.Draft &&
          this.privileges.canUnsubmit) ||
        (this.scfMaster?.status == FormStatusEnum.AmendmentPending &&
          this.privileges.canUnsubmitAmendment);
  }

  async changeAmendmentToggle(e: any) {
    if (await this.canDeactivate()) {
      this.status.isViewingAmendment = e.checked;
      this.checkPrivileges();
    }
  }

  canSeeAmendment(): boolean {
    let res = this.hasPrivilege(PrivilegeEnum.SCFSubmit);
    if (res) {
      return true;
    }
    res = this.hasPrivilege(PrivilegeEnum.SCFSubmitAmendment);
    if (res) {
      return true;
    }
    res = this.hasPrivilege(PrivilegeEnum.SCFNewForm);
    if (res) {
      return true;
    }
    res = this.hasPrivilege(PrivilegeEnum.EditSCFAmendment);
    if (res) {
      return true;
    }
    res = this.hasPrivilege(PrivilegeEnum.ViewSCFAmendment);
    if (res) {
      return true;
    }
    res = this.scfMaster?.requesterId == this.currentUser?.id || this.scfMaster?.scfAmendments?.find(a => a.active)?.requesterId == this.currentUser?.id;
    if (res) {
      return true;
    }
    return false;
  }

  isRequester() {
    return true;
  }

  checkDisabled() {
    this.disabled = true;
    if (!this.currentUser) {
      return;
    } else {
      this.disabled = !(
        this.scfMaster?.status === FormStatusEnum.New ||
        this.scfMaster?.status === FormStatusEnum.Draft ||
        (this.scfMaster?.status === FormStatusEnum.AmendmentDrafting &&
          this.status.isViewingAmendment)
      );
    }
  }

  checkPrivileges() {
    this.checkDisabled();
    const user = this.currentUser;
    this.privileges = new SCFPrivileges();
    this.privileges = {
      canCreate: this.hasPrivilege(PrivilegeEnum.SCFNewForm),
      canEdit:
        (this.scfMaster?.status == FormStatusEnum.Draft ||
          this.scfMaster?.status == FormStatusEnum.New) &&
        this.hasPrivilege(PrivilegeEnum.SCFNewForm) &&
        (!this.scfMaster?.editingBy ||
          this.scfMaster?.editingBy?.id == user?.id),
      canSubmit:
        (this.scfMaster?.status == FormStatusEnum.Draft ||
          this.scfMaster?.status == FormStatusEnum.New) &&
        this.hasPrivilege(PrivilegeEnum.SCFSubmit),
      canCancel:
        (this.scfMaster?.status == this.formStatusEnum.Draft ||
          this.scfMaster?.status == FormStatusEnum.New ||
          this.scfMaster?.status == FormStatusEnum.WorkApprovals ||
          this.scfMaster?.status == FormStatusEnum.PendingActivation) &&
        this.hasPrivilege(PrivilegeEnum.SCFSubmit),
      canUnsubmit:
        this.scfMaster?.status == this.formStatusEnum.WorkApprovals &&
        this.hasPrivilege(PrivilegeEnum.SCFSubmit) &&
        this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find((x) => x.number == 2)?.wfSignatures?.filter((x) => x.code != "SUBMIT" && x.signed).length ==
        0,
      canDisapprove: // OIC Disapprove
        (this.scfMaster?.status == this.formStatusEnum.WorkApprovals || this.scfMaster?.status == this.formStatusEnum.PendingActivation) &&
        this.hasPrivilege(PrivilegeEnum.SCFSubmit) && this.hasRoles([this.roleEnum.OIC]),
      canCreateAmendment:
        (this.scfMaster?.status == FormStatusEnum.Active ||
          this.scfMaster?.status == FormStatusEnum.HoldPoint) &&
        this.hasPrivilege(PrivilegeEnum.RequestAmendment),
      canEditAmendment:
        this.scfMaster?.status == FormStatusEnum.AmendmentDrafting &&
        this.hasPrivilege(PrivilegeEnum.EditSCFAmendment),
      canSubmitAmendment:
        this.scfMaster?.status == FormStatusEnum.AmendmentDrafting &&
        this.hasPrivilege(PrivilegeEnum.SCFSubmitAmendment),
      canUnsubmitAmendment:
        this.scfMaster?.status == FormStatusEnum.AmendmentPending &&
        this.hasPrivilege(PrivilegeEnum.SCFSubmitAmendment) &&
        !this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find(x => x.number == 6)?.wfSignatures?.filter(x =>
          x.amendmentID == this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find(x => x.number == 6)?.wfSignatures?.find(x => x.amendmentNumber == this.scfMaster?.scfAmendments?.length
          )?.amendmentID
        )
          .some((x) => x.signed),
      canCancelAmendment:
        (this.scfMaster?.status == FormStatusEnum.AmendmentDrafting ||
          this.scfMaster?.status == FormStatusEnum.AmendmentApprovals ||
          this.scfMaster?.status == FormStatusEnum.AmendmentPending) &&
        this.hasPrivilege(PrivilegeEnum.SCFSubmitAmendment),
      canViewAmendment: (this.scfMaster && this.canSeeAmendment()) ?? false,
      canAddHoldPoints:
        (this.scfMaster &&
          this.hasPrivilege(PrivilegeEnum.CreateHoldPoints) &&
          (this.scfMaster.status == FormStatusEnum.AmendmentDrafting)) ?? false,
      canAddHoldPointsDraft:
        (this.scfMaster &&
          this.hasPrivilege(
            PrivilegeEnum.CreateHoldPointsDraft
          ) &&
          this.scfMaster.status == FormStatusEnum.Draft) ?? false,
      canDuplicate:
        (this.scfMaster &&
          this.hasPrivilege(PrivilegeEnum.CopySCF)) ?? false,
      canRelease:
        this.canReleaseEditingForm(),
    };
  }

  async duplicate() {
    if (await this.canDeactivate()) {
      const removeRef = this.dialog.open(YesNoDialogComponent, {
        width: "20em", data: {
          message: this.getMessage(
            "Are you sure you want to copy this form"
          ).description, icon: "warn", val: false,
        },
      });
      removeRef
        .afterClosed()
        .toPromise()
        .then((result) => {
          if (result != null && result) {
            const id = this.scfMaster?.id ?? 0;
            this.side.rowUnselected();
            this.scfService
              .copySCF(id, false)
              .toPromise()
              .then(async (scfMaster) => {
                this.scfMaster = scfMaster;

                if (this.scfMaster)
                  await this.side.getValues(this.scfMaster);
              })
              .catch((error) => {
                console.log(error);
                this.alert.message("defaultErrorMessage");
              });
          }
        });
    }
  }

  async requestAmendment() {
    if (await this.canDeactivate()) {
      const pendingChanges = this.scfMaster?.wfTable?.wfTableLocal?.wfSectionLocals?.find(x => x.number == 4)?.wfSignatures?.filter(x => !x.wfTaskLocal.amendmentID)?.filter(x => x.answerChangedBy);
      if (!pendingChanges?.length) {
        const confirm = this.dialog.open(YesNoDialogComponent, {
          width: "500px", data: {
            message: this.getMessage("request_amendment")?.description, icon: "warn",
          },
        });
        confirm.afterClosed().subscribe(async (data) => {
          if (data) {
            if (this.scfMaster?.id)
              this.scfService.requestAmendment(this.scfMaster.id).toPromise().then(() => {
                this.status.isCreatingAmendment = true;
                this.status.isViewingAmendment = true;
              }, (error) => {
                console.log(error);
                this.alert.message("defaultErrorMessage");
              }
              );
          }
        });
      } else {
        this.alert.message("OperationApprovalPendingChanges");
      }
    }
  }

  setStatus(status: FormViewState | any) {
    this.status = status;
  }

  savedEvent(e: SCFMaster | null | undefined | any) {
    this.scfMaster = e;
    this.scfMasterUnchanged = utils.cloneDeep(this.scfMaster);
    this.rowSelected(e);
  }

  saveEvent() {
    if (this.main) {
      const s5 = this.main.section5;
      if (s5) {
        s5.saveOPApprovalChanges();
      }
    }
  }

  mainValid(): boolean {
    return this.main?.formValid();
  }

}
